import { EditView } from "@/core/magnet";
import app from "@/app";
import qs from "qs";
const { notify } = useNotifications();

// Services
import { useTrackingEvents } from "@composables/trackingevents";
import { useFeaturesStore, useIntegrationsStore } from "@store";

// Composables
import { useNotifications } from "@composables/notifications";

export default EditView.extend({
  gender: "F",

  // Performs the needed bindings before renderization
  beforeRender: function (callback) {
    if (this.item.attributes.options?.UNLAYER_TPL_ID && !app.session.attributes.isGuest) {
      this.useUnlayer = true;
      this.unlayerTemplateId = this.item.attributes.options?.UNLAYER_TPL_ID;
    }

    const integrationStore = useIntegrationsStore();

    const isEcommerce = integrationStore.ecommerceIntegrations.length > 0;

    // Get list display preference
    this.showConversionsColumn = isEcommerce;

    // Continue with rendering
    callback();
  },

  // Returns the data to be rendered by the template function
  renderData: function () {
    return {
      data: this.item,
      lang: window.lang,
      config: window.config,
      session: app.session,
      isDesktop: window.innerWidth > 640,
      splitABSubjects: this.item.splitABSubjects(),
      version: this.options.version,
      useUnlayer: this.useUnlayer,
      showConversionsColumn: this.showConversionsColumn,
    };
  },

  createModelInstance: function (options) {
    return new app.models[this.module]({
      id: options.id,
      version: options.version,
    });
  },

  // Performs an action before fetching the model
  beforeFetch: function (params) {
    $(".mobile-splash").addClass("hidden");
    this.item;
    return params;
  },

  // Opens the share modal
  openShareModal: function () {
    this.item.share().done(
      function (response) {
        this.openModal(require("../templates/modals/share.hbs"), {
          data: this.item,
          link: `${window.location.origin}/${response.data.replace("&", "?").replace("#", "")}`,
        });
      }.bind(this),
    );
  },

  // Selects the text in the image link input
  selectShareLinkText: function () {
    document.getElementById("share").select();
  },

  // Copies the image link to the clipboard
  copyShareUrl: function (e) {
    var button = $(e.currentTarget);
    this.selectShareLinkText();
    if (document.execCommand("copy")) {
      button.text(window.lang.done);
    }
  },

  // Opens the duplicate modal
  openDuplicateModal: function () {
    const isEddie = this.isEddieTemplate();
    let cantDuplicate =  false;
    this.item.attributes.isEddie = isEddie;

    if (isEddie) {
      const trackingEventsService = useTrackingEvents();
      const eddieFeatures = this.getEddieFeatures();
      cantDuplicate = !eddieFeatures.allow_eddie_duplicate;

      if (eddieFeatures) {
        trackingEventsService.amplitude({
          name: "APP_EDDIE_DUPLICATE_NOTIFICATION",
          data: {
            source: "campaign",
            id: this.item.id,
            feature_unlayer_optional: eddieFeatures.unlayer_optional,
            feature_unlayer_default: eddieFeatures.unlayer_default,
            feature_hide_legacy_templates: eddieFeatures.hide_legacy_templates,
          },
        });
      }
    }

    this.openModal(require("../templates/modals/duplicate.hbs"), {
      data: this.item,
      cantDuplicate: cantDuplicate,
    });
  },

  // Duplicates the campaign
  duplicate: function (e) {
    var form = e.currentTarget,
      data = $(form).serializeObject();
    e.preventDefault();

    // Validate values
    if (!this.validateFormFields(form)) {
      return this;
    }

    // Send request
    this.item.duplicate(data).done(
      function (response) {
        this.getModal().modal("hide");
        app.router.navigateTo(`campaigns/${response.data.id}`);
      }.bind(this),
    );
  },

  isEddieTemplate: function () {
    const campaigns = this.item.attributes;
    if (!campaigns) return undefined;
    return !campaigns.options.UNLAYER_TPL_ID;
  },

  getEddieFeatures: function () {
    const featuresStore = useFeaturesStore();
    const features = featuresStore.features;

    if (!features) return undefined;

    const eddieFeatures = {
      unlayer_optional: features.UNLAYER_OPTIONAL === "1" ? true : false,
      unlayer_default: features.UNLAYER_DEFAULT === "1" ? true : false,
      hide_legacy_templates: features.HIDE_LEGACY_TEMPLATES === "1" ? true : false,
      allow_eddie_duplicate: features.ALLOW_EDDIE_DUPLICATE === "1" ? true : false,
    };
    return eddieFeatures;
  },

  // Archives campaigns
  archive: function () {
    this.item.archive().done(function () {
      app.router.navigateTo("campaigns");
    });
  },

  // Unarchives campaigns
  unarchive: function () {
    this.item.unarchive().done(function () {
      app.router.navigateTo("campaigns");
    });
  },

  // Stops a campaign
  stop: function (e) {
    const self = this;
    var button = $(e.currentTarget);

    // Abort if the button has a confirm data attribute
    if (button.attr("data-confirm")) {
      return false;
    }

    // Stop via API
    this.item.stop().done(function () {
      self.displayMessage(window.lang.campaigns.sendingStopped);
      app.router.navigateTo("campaigns");
    });
  },

  // Redirect to contents if the campaign is pending
  redirectToContents: function (campaign) {
    if (campaign.state === "SCHEDULED" || campaign.state === "PENDING_APPROVAL") {
      app.router.navigateTo(`metrics/${campaign.id}/contents`);
    }
  },

  // Opens the sent criterias modal
  openCriteriasModal: function (e) {
    e.preventDefault();

    // Open modal
    this.openModal(require("../templates/modals/criterias.hbs"), {
      data: this.item,
      session: app.session,
    });
  },

  join: function () {
    const self = this;
    const apiUrl = "lists/join";
    const listIds = this.item.attributes.include.lists;
    const campaignName = this.item.attributes.name;

    const truncateString = (str) => {
      if (str.length <= 50) return str;
      return str.slice(0, 50);
    };

    const randomString = (length) => {
      const characters = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      return Array.from({ length }, () => characters[Math.floor(Math.random() * characters.length)]).join("");
    };

    const newListName = truncateString("_admin-" + randomString(3) + "-" + campaignName);

    return $.ajax({
      type: "POST",
      url: apiUrl,
      data: qs.stringify({
        newListName: newListName,
        listIds: listIds,
      }),
      success: function () {
        notify({
          text: window.lang.lists.feedback.joined,
          theme: "info",
        });
      },
      error: function () {
        notify({
          text: window.lang.ajaxError,
          theme: "error",
        });
      },
    });
  },
});
